import React from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';

const MeetingFormPlaceholder: React.FC<any> = ({ initialData = {}, onSave, onCancel }) => {
  const [title, setTitle] = React.useState(initialData.title || '');
  const [participants, setParticipants] = React.useState(initialData.participants || '');
  const [time, setTime] = React.useState(initialData.time || '');

  return (
    <View style={styles.wrap}>
      <Text style={styles.heading}>Meeting (占位表单)</Text>
      <TextInput style={styles.input} placeholder="标题" value={title} onChangeText={setTitle} />
      <TextInput style={styles.input} placeholder="参与者（逗号分隔）" value={participants} onChangeText={setParticipants} />
      <TextInput style={styles.input} placeholder="时间" value={time} onChangeText={setTime} />
      <View style={styles.actions}>
        <TouchableOpacity onPress={() => onCancel && onCancel()} style={[styles.btn, styles.cancel]}>
          <Text>取消</Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={() => onSave && onSave({ title, participants: participants.split(',').map((s: string) => s.trim()), time })} style={[styles.btn, styles.save]}>
          <Text style={{ color: '#fff' }}>保存</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: { padding: 12 },
  heading: { fontSize: 18, fontWeight: '700', marginBottom: 12 },
  input: { borderWidth: 1, borderColor: '#eee', padding: 8, marginBottom: 8, borderRadius: 6 },
  actions: { flexDirection: 'row', justifyContent: 'flex-end' },
  btn: { padding: 8, borderRadius: 6, marginLeft: 8 },
  cancel: { backgroundColor: '#f3f4f6' },
  save: { backgroundColor: '#0ea5ff' },
});

export default MeetingFormPlaceholder;
